<template>
	<button
		class="relative btn p-3 bg-white w-full text-primary-superdark text-start rounded-xl border border-gray flex items-center hover:bg-gray-light focus:bg-gray-light"
		:title="props.item.channelName"
		@click.prevent="openChat()"
	>
		<aside class="shrink-0 pe-3">
			<ChannelIcon
				:type="props.item.isArchived ? 'archive' : 'active'"
			></ChannelIcon>
		</aside>
		<div class="grow min-w-px">
			<p class="truncate">{{ props.item.channelName }}</p>
			<p :class="['text-sm font-light text-gray-dark truncate']">
				{{ props.item.lastMessageText }}
			</p>
		</div>
		<aside class="shrink-0 self-start ps-3">
			<div class="text-sm text-end text-gray-darker font-light text-nowrap">
				<time :datetime="props.item.lastMessageDateTime" :title="renderedDate">
					{{ renderedDate }}
				</time>
			</div>

			<div
				class="text-sm text-end font-light text-nowrap pt-1"
				v-if="props.item.unseenMessageCount"
			>
				<div
					class="h-6 min-w-6 px-2 text-sm text-white bg-red rounded-full inline-flex items-center justify-center leading-none"
					:title="`Počet nových zpráv: ${props.item.unseenMessageCount}`"
				>
					{{ props.item.unseenMessageCount }}
				</div>
			</div>
		</aside>
	</button>
</template>

<script setup lang="ts">
import type { Props } from '@/types/ChatListItem'
import ChannelIcon from './ChannelIcon.vue'
import { useRouter } from 'vue-router'
import { formatDate } from '@/services/dateTimeService'
import { computed } from 'vue'
const router = useRouter()
const props = defineProps<Props>()

const openChat = () => {
	router.push({ name: 'Chat', params: { channelId: props.item.channelId } })
}

const renderedDate = computed<string>(() => {
	return formatDate(props.item.lastMessageDateTime, {
		autoFormat: true,
		showTime: true
	})
})
</script>

<style scoped></style>
